import React, { useEffect, useState } from "react";
import "./index.less";
import type { Dayjs } from "dayjs";
import { Col, DatePicker, Row } from "antd";
import moment from "moment";
import Charts from "../Charts";
import { analysisApi, useGetAnalysisQuery } from "services/analysisService";
import i18n from "i18next";
import { decodeJWT } from "common/functions";
import { useSelector, useDispatch } from "react-redux";
import { rootReducerType } from "redux/combineReducers";
// import { ControlOutlined } from "@ant-design/icons";
// import { start } from "repl";
import { emailToUsername } from "common/utils";
import { useGetActiveAnalysisQuery } from "services/analysisService";

interface IProps {
  station: string;
  shouldRefresh: boolean;
  apiFun: Function;
}

const { RangePicker } = DatePicker;
const ChartContainer: React.FC<IProps> = (props) => {
  const dispatch = useDispatch();
  const [preset, setPreset] = useState<string>("30days");
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const { station = "all", shouldRefresh, apiFun } = props;
  const { isLoggedIn } = useSelector(
    (state: rootReducerType) => state.authenticationReducer
  );
  const [params, setParams] = useState<any>({
    userName: emailToUsername(decodeJWT(isLoggedIn).email),
  });
  const { data: activeAnalysis } = useGetActiveAnalysisQuery(params);
  // console.log("active", activeAnalysis);

  const { shouldRefresh: shouldRefreshs } = useSelector(
    (state: rootReducerType) => state.anaChartReducer
  );

  let startTime = moment(new Date()).subtract(30, "days").format("YYYY-MM-DD");
  let endTime = moment().subtract(1, "days").format("YYYY-MM-DD");

  const rangeList: any = {
    "Past 7 days": [
      moment().startOf("day").subtract(1, "weeks"),
      moment().subtract(1, "days"),
    ],
    "Past 30 days": [
      moment().startOf("day").subtract(30, "days"),
      moment().subtract(1, "days"),
    ],
    "Past 90 days": [
      moment().startOf("day").subtract(91, "days"),
      moment().subtract(1, "days"),
    ],
    "Past 180 days": [
      moment().startOf("day").subtract(181, "days"),
      moment().subtract(1, "days"),
    ],
    "Past year": [
      moment().startOf("day").subtract(1, "year"),
      moment().subtract(1, "days"),
    ],
  };
  const tagListValue: any = {
    "Past 7 days": "7days",
    "Past 30 days": "30days",
    "Past 90 days": "90days",
    "Past 180 days": "180days",
    "Past year": "oneYear",
  };

  useEffect(() => {
    // apiFun(refetch)
    refetch();
  }, [shouldRefreshs]);

  let { data: analysisData = {} as any, refetch } = useGetAnalysisQuery({
    preset,
    station,
    startDate,
    endDate,
  });
  if (
    !preset &&
    startDate &&
    endDate &&
    analysisData?.Items &&
    analysisData?.Items.length
  ) {
    // console.log(analysisData);
    // console.log(startDate, endDate);
    analysisData = calculateAggregatedData(
      analysisData?.Items,
      startDate,
      endDate,
      activeAnalysis
    );
  }

  // if (!preset && startDate && endDate) {
  //   analysisData = {}
  //   console.log("custom date range")
  // } else if (analysisData?.Items && analysisData?.Items.length) {
  //   console.log("preset")
  //   let keys = Object.keys(analysisData.Items[0])
  //   keys = keys.filter(i => (i !== 'chargerId' && i !== 'endTime' && i !== 'startTime'))
  //   const newKeys = analysisData?.Items.reduce((prev, next) => {
  //     prev.push({ date: `${moment(next.startTime).format('YYYY-MM-DD HH:mm:ss')}-${moment(next.endTime).format('YYYY-MM-DD HH:mm:ss')}` })
  //     return prev
  //   }, [])

  //   const arrData = keys.map(i => {
  //     return analysisData?.Items.reduce((prev, cur) => {
  //       prev.push(cur[i])
  //       return prev
  //     }, [])
  //   })

  //   const new_analysisData = {}
  //   keys.forEach((i, inx) => {
  //     const new_analysisItem = {}
  //     newKeys.forEach((val, index) => {
  //       new_analysisItem[val['date']] = arrData[inx][index]
  //     })
  //     new_analysisData[i] = { ...new_analysisItem }
  //   })
  //   try {
  //     new_analysisData['total'] = eval(Object.values(new_analysisData || {}).join('+'))
  //   } catch (error) {
  //   }
  //   analysisData = new_analysisData;
  //   if(analysisData.chargingDuration) delete analysisData.chargingDuration
  // }
  const getTag = (dateArr: any) => {
    if (
      dateArr[1].format("DD/MM/YYYY") !==
      moment().subtract(1, "days").format("DD/MM/YYYY")
    )
      return null;
    const _tag = Object.keys(rangeList).find((i) =>
      dateArr[0].isSame(rangeList[i][0])
    );
    return _tag ? tagListValue[_tag] : null;
  };

  const onRangeChange = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[]
  ) => {
    setNewDatesUpdate(dates);
  };

  useEffect(() => {
    dispatch(
      analysisApi.endpoints.getAnalysis.initiate(
        {
          station,
          preset,
          startDate,
          endDate,
        },
        { subscribe: false, forceRefetch: true }
      )
    );
  }, [station, preset, dispatch, startDate, endDate, shouldRefresh]);

  function camelCaseToTitleCase(inputString) {
    // 使用正则表达式将驼峰命名法转换为以空格分隔的单词
    var titleCaseString = inputString.replace(/([A-Z])/g, " $1");

    // 将结果的首字母大写
    titleCaseString =
      titleCaseString.charAt(0).toUpperCase() + titleCaseString.slice(1);

    // 处理 "KWh" 的情况
    titleCaseString = titleCaseString
      .replace(/K Wh/g, "KWh")
      .replace(/kWh/g, "kWh");

    return titleCaseString;
  }

  function generateDateRange(startDate, endDate) {
    let current = moment(startDate);
    const end = moment(endDate).add(1, "days");
    const dateFormat = end.diff(current, "years") >= 1 ? "YYYY-MM-DD" : "MM-DD";
    const range: string[] = [];

    while (current.isBefore(end, "day")) {
      range.push(current.format(dateFormat));
      current.add(1, "days");
    }

    return range;
  }

  function calculateAggregatedData(items, startDate, endDate, activeAnalysis) {
    let current = moment(startDate);
    const end = moment(endDate);
    const dateFormat = end.diff(current, "years") >= 1 ? "YYYY-MM-DD" : "MM-DD";

    // Initialize the aggregated data object with all metrics
    const aggregatedData = {
      sessionNum: { total: 0, unit: "sessions" },
      sessionLength: { total: 0, unit: "hours" },
      energy: { total: 0, unit: "kWh" },
      revenue: { total: 0, unit: "dollars" },
      avgLength: { total: 0, unit: "hours per session" },
      avgEnergy: { total: 0, unit: "kWh per session" },
      avgRevenuePerSession: { total: 0, unit: "dollars per session" },
      avgRevenuePerKWh: { total: 0, unit: "dollars per kWh" },
    };
    // console.log("items", items.length);
    // console.log("aggregatedData0", aggregatedData);

    // Initialize data structure with dates in the range
    while (current <= end) {
      const dayKey = current.format(dateFormat);
      Object.keys(aggregatedData).forEach((key) => {
        if (!aggregatedData[key].hasOwnProperty(dayKey)) {
          aggregatedData[key][dayKey] = 0;
        }
      });
      current.add(1, "days");
    }
    // console.log("aggregatedData1", aggregatedData);

    // Perform aggregation for all metrics
    items.forEach((item) => {
      const dayKey = moment(item.endTime).format(dateFormat);
      if (aggregatedData.sessionNum.hasOwnProperty(dayKey)) {
        aggregatedData.sessionNum[dayKey]++;
        aggregatedData.sessionLength[dayKey] += item.sessionLength / 60; // Convert minutes to hours
        aggregatedData.energy[dayKey] += item.energy / 1000; // Assuming energy is in Wh
        aggregatedData.revenue[dayKey] += item.revenue;

        aggregatedData.sessionNum.total++;
        aggregatedData.sessionLength.total += item.sessionLength / 60;
        aggregatedData.energy.total += item.energy / 1000;
        aggregatedData.revenue.total += item.revenue;
      }
    });

    // Calculate averages for each metric
    Object.keys(aggregatedData.sessionNum).forEach((dayKey) => {
      if (dayKey !== "total" && dayKey !== "unit") {
        const numSessions = aggregatedData.sessionNum[dayKey];
        const totalEnergy = aggregatedData.energy[dayKey];
        const totalRevenue = aggregatedData.revenue[dayKey];

        aggregatedData.avgLength[dayKey] =
          numSessions > 0
            ? parseFloat(
                (aggregatedData.sessionLength[dayKey] / numSessions).toFixed(2)
              )
            : 0;

        aggregatedData.avgEnergy[dayKey] =
          numSessions > 0
            ? parseFloat((totalEnergy / numSessions).toFixed(2))
            : 0;

        aggregatedData.avgRevenuePerSession[dayKey] =
          numSessions > 0
            ? parseFloat((totalRevenue / numSessions).toFixed(2))
            : 0;

        aggregatedData.avgRevenuePerKWh[dayKey] =
          totalEnergy > 0
            ? parseFloat((totalRevenue / totalEnergy).toFixed(2))
            : 0;
      }
    });

    // Calculate total averages
    const totalSessions = aggregatedData.sessionNum.total;

    aggregatedData.avgLength.total =
      totalSessions > 0
        ? parseFloat(
            (aggregatedData.sessionLength.total / totalSessions).toFixed(2)
          )
        : 0;

    aggregatedData.avgEnergy.total =
      totalSessions > 0
        ? parseFloat((aggregatedData.energy.total / totalSessions).toFixed(2))
        : 0;

    aggregatedData.avgRevenuePerSession.total =
      totalSessions > 0
        ? parseFloat((aggregatedData.revenue.total / totalSessions).toFixed(2))
        : 0;

    aggregatedData.avgRevenuePerKWh.total =
      aggregatedData.energy.total > 0
        ? parseFloat(
            (
              aggregatedData.revenue.total / aggregatedData.energy.total
            ).toFixed(2)
          )
        : 0;

    // Filter results to include only active metrics
    const filteredResults = {};
    activeAnalysis.forEach((metric) => {
      if (aggregatedData[metric]) {
        filteredResults[metric] = aggregatedData[metric];
      }
    });

    // console.log("calculateAggregatedData", filteredResults);
    return filteredResults;
  }

  const [isOpenRangePicker, setIsOpenRangePicker] = useState<boolean>(false);
  const [newDatesUpdate, setNewDatesUpdate] = useState<any>(null);

  const onRangePickerChange = (open: boolean) => {
    setIsOpenRangePicker(open);
  };

  useEffect(() => {
    if (!isOpenRangePicker && newDatesUpdate) {
      if (newDatesUpdate) {
        if (getTag(newDatesUpdate)) {
          setPreset(getTag(newDatesUpdate) || "");
          setEndDate(null);
          setStartDate(null);
        } else {
          setPreset("");
          setEndDate(
            newDatesUpdate[1]
              ? newDatesUpdate[1].format("YYYY-MM-DDTHH:mm:[00]")
              : null
          );
          setStartDate(
            newDatesUpdate[0]
              ? newDatesUpdate[0].format("YYYY-MM-DDTHH:mm:[00]")
              : null
          );
        }
      }
    }
  }, [isOpenRangePicker]);

  return (
    <div className="chartContainer">
      <div className="dateWrap">
        <RangePicker
          ranges={rangeList}
          defaultValue={[moment(startTime), moment(endTime)]}
          onChange={onRangeChange as any}
          open={isOpenRangePicker}
          onOpenChange={onRangePickerChange}
        />
      </div>
      <div className="chartList">
        <Row gutter={24}>
          {Object.keys(analysisData || {}).map((i) => {
            if (i != "cutOffOrder") {
              return (
                <Col xs={24} sm={12} md={8} key={i}>
                  <div className="wrap">
                    <div className="title">{camelCaseToTitleCase(i)}</div>
                    <div className="total">
                      {parseFloat(analysisData[i]?.total || 0).toFixed(2)}{" "}
                      {analysisData[i]?.unit}
                    </div>
                    <div className="chartWrap" style={{ paddingRight: "5px" }}>
                      <Charts
                        chartLabel={i}
                        value={analysisData[i]}
                        unit={i18n.t(`unitMap.${i}`)}
                        order={analysisData.cutOffOrder}
                      />
                    </div>
                  </div>
                </Col>
              );
            }
          })}
        </Row>
      </div>
    </div>
  );
};

export default ChartContainer;
